export default 'M17.75 13.25H6.25a1.25 1.25 0 0 1 0-2.5h11.5a1.25 1.25 0 0 1 0 2.5M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24';